import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import AbstractSelect from '../abstract-select/abstract-select';
import { CenterSetting } from '@core/interfaces/center-setting';
import { get } from 'lodash';
import { CenterSettingsFilter } from '@shared/interfaces/config';

@Component({
  name: 'bpc-multi-select',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-field-wrapper': FieldWrapper,
    'v-select': vSelect,
  },
})
export default class MultiSelect extends mixins(AbstractField, AbstractSelect) {
  @Prop(Array) readonly options: object[];
  @Prop({ type: Boolean, default: false }) readonly withDescription: boolean;

  private filteredOptions: object[] = [];
  public selectedDescription: string = '';

  get centerSetting(): CenterSetting {
    return this.$store.getters['centerSettings/centerSettings'];
  }

  mounted() {
    this.filteredOptions = this.filterOptions(this.options);
    if (this.withDescription) {
      const description = this.options.find(obj => {
        const castedObject = obj as AnyEntity;
        return castedObject.value === this.value;
      });
      this.selectedDescription = this.$t(description['description']) as string;
      // The next line removes all html tags to display the description in one line (for activity type description).
      // If this is a problem for another use, it can be removed.
      this.selectedDescription = this.selectedDescription.replace(/(<([^>]+)>)/gi, '');
    }
  }

  onChange(event) {
    this.filteredOptions = this.filterOptions(this.options);
    if (this.withDescription) {
      const description = this.options.find(obj => {
        const castedObject = obj as AnyEntity;
        return castedObject.value === event;
      });
      this.selectedDescription = this.$t(description['description']) as string;
      // The next line removes all html tags to display the description in one line (for activity type description).
      // If this is a problem for another use, it can be removed.
      this.selectedDescription = this.selectedDescription.replace(/(<([^>]+)>)/gi, '');
    }
  }

  filterOptions(options) {
    return options
      .filter(option => {
        if (option.module) {
          return this.checkModulePermissions(option.module);
        }
        return true;
      })
      .filter(option => {
        if (option.centerSettings) {
          return this.checkCenterSettings(option.centerSettings);
        }
        return true;
      });
  }

  checkCenterSettings(centerSettings: CenterSettingsFilter): boolean {
    const fieldPath = get(centerSettings, 'fieldPath', null);
    const operator = get(centerSettings, 'operator', null);
    const value = get(centerSettings, 'value', null);
    const centerSettingValue = get(this.centerSetting, fieldPath, null);

    return this.compare(operator, value, centerSettingValue);
  }

  compare(operator, currentValue, targetValue) {
    switch (operator) {
      case '=':
        return currentValue == targetValue;
      case '!=':
        return currentValue != targetValue;
      case '>':
        return currentValue > targetValue;
      case '<':
        return currentValue < targetValue;
      case '>=':
        return currentValue >= targetValue;
      case '<=':
        return currentValue <= targetValue;
      case 'in':
        return targetValue.indexOf(currentValue) > -1;
      default:
        return false;
    }
  }

  checkModulePermissions(mod: string): boolean {
    const hasModuleActivated = this.$modulesService.hasModuleActivated(mod);
    if (hasModuleActivated) {
      return true;
    }

    return false;
  }

  get translatedOptions() {
    return this.filteredOptions.map(option => {
      const newOption = {};
      newOption[this.selectLabel] = this.$t(option[this.selectLabel]);
      newOption[this.selectValue] = option[this.selectValue];
      if (this.withDescription) {
        newOption['description'] = this.$t(option['description']);
      }
      return newOption;
    });
  }

  extendHandleEvent(eventName: string, event: any, val: any) {
    this.model = null;
    this.filteredOptions = [];
    if (event.action === 'updateFilterOptions' && val !== null) {
      event.filters.forEach(filter => {
        this.filteredOptions = this.filteredOptions.concat(
          this.options.filter(option => option[filter['field']] == val),
        );
      });
    } else {
      this.filteredOptions = this.options;
    }
  }
}
